// @flow
import Service from './service';
import type { IfpAppType } from '../types/ifp-app';

export default class CartService extends Service {
  purchase(payload: {
    appIds: Array<string>,
    billingId: string|number,
    effectiveDate: string,
  } = {
    appIds: [],
    billingId: '',
    effectiveDate: '',
  }):Promise<Array<IfpAppType>> {
    const { appIds, effectiveDate } = payload;
    const bodyComplete = appIds.length && effectiveDate;
    if (!bodyComplete) {
      return Promise.reject({ err: 'Incomplete payload' });
    }
    return this.api.post(`${this.baseUrl}/cart/purchase`, payload)
      .then(res => res.data);
  }

  get(params: Object = {}): Promise<Array<IfpAppType>> {
    return this.api.get(`${this.baseUrl}/cart`, { params })
      .then(res => res.data);
  }
}
